import { c as _c } from "react/compiler-runtime";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { translate } from '@openclassrooms/translations';
import Button from '@classify/react-core-components/Button';
import Box from '@classify/react-core-components/Box';
import { HelpType } from './ContactProvider/useHelpTypeFromPathname';
interface Props {
  type: HelpType;
}
export default function Footer(t0) {
  const $ = _c(9);
  const {
    type
  } = t0;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t1;
  if ($[0] !== getLocalisationConfig || $[1] !== type) {
    t1 = type === "employer" ? String(getLocalisationConfig("faq.employer.url")) : String(getLocalisationConfig("faq.student.url"));
    $[0] = getLocalisationConfig;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const faqUrl = t1;
  if (!getLocalisationConfig("contact.faq.show")) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textAlign: "right",
      pb: 3
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OpenInNewIcon />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `Navigation|Redirection::External|support-panel|faq-${type}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("global.word.see_faq.action");
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== faqUrl || $[7] !== t4) {
    t6 = <Box sx={t2}><Button variant="tertiary" endIcon={t3} target="_blank" href={faqUrl} data-event={t4}>{t5}</Button></Box>;
    $[6] = faqUrl;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}